import {buttonClasses, ThemeOptions} from '@mui/material'

export const BackgroundColor = '#f9f9f9'
export const FocusedBorderColor = '#2684FF'
export const HoverBorderColor = '#b3b3b3'

// prevent jquery mobile from enhancing elements with portals
const disableJQM = {'data-enhance': 'false'}
export const baseMuiTheme = {
	palette: {
		common: {
			black: "#000",
			white: "#fff",
		},
		background: {
			paper: "#fff",
			"default": "#fafafa",
		},
		primary: {
			light: "#a7b6c6",
			main: "#376798",
			dark: "#15406d",
			contrastText: "#fff",
		},
		secondary: {
			light: "#81c784",
			main: "#3ebe28",
			dark: "#1b8b0c",
			contrastText: "#fff",
		},
		error: {
			light: "#e57373",
			main: "#e3391d",
			dark: "#ae1500",
			contrastText: "#fff",
		},
		warning: {
			light: "#fbf778",
			main: "#fbe300",
			dark: "#cbb800",
			contrastText: "#000",
		},
		text: {
			primary: "rgba(0, 0, 0, 0.87)",
			secondary: "rgba(0, 0, 0, 0.54)",
			disabled: "rgba(0, 0, 0, 0.38)",
			hint: "rgba(0, 0, 0, 0.38)",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					minWidth: 40,
					[`&.${buttonClasses.outlined}`]: {
						border: '1px solid rgba(0, 0, 0, 0.23)',
					},
				},
			},
			defaultProps: {
				color: 'inherit',
			},
		},
		MuiButtonGroup: {
			defaultProps: {
				color: 'inherit',
			},
		},
		MuiDialog: {
			defaultProps: disableJQM,
			styleOverrides: {
				paper: {
					backgroundColor: BackgroundColor,
				},
			},
		},
		MuiDivider: {
			styleOverrides: {
				root: {
					marginTop: 10,
					marginBottom: 10,
				},
			},
		},
		MuiDrawer: {
			defaultProps: disableJQM,
		},
		MuiFormControl: {
			defaultProps: {
				variant: 'standard',
			},
		},
		MuiListSubheader: {
			styleOverrides: {
				root: {
					marginLeft: 1,
					marginRight: 1,
				},
			},
		},
		MuiSelect: {
			defaultProps: {
				variant: 'standard',
			},
		},
		MuiTextField: {
			defaultProps: {
				variant: 'standard',
			},
		},
		MuiTooltip: {
			defaultProps: {
				placement: "top",
				enterDelay: 500,
			},
			styleOverrides: {
				popper: {
					zIndex: 9999,
				},
				popperInteractive: {
					zIndex: 9999,
				},
				tooltip: {
					color: "#000",
					backgroundColor: "#fff",
					fontSize: "14px",
					boxShadow: "2px 2px 20px 3px rgba(0,0,0,0.4)",
					maxWidth: 800,
					/** fixes, when tooltip gets bigger than screen, it gets scrollable (and top bars still visible) */
					maxHeight: "calc(100vh - 120px)",
					overflowY: "auto",
				},
			},
		},
	},
} as ThemeOptions